import React, { useState } from "react";
import styles from "./StaffMessages.module.css";
import TabSelector from "../../components/TabSelector/TabSelector";
import SearchBar from "../../components/SearchBar/SearchBar";
import AllMessaging from "../../sections/AllMessaging/AllMessaging";
import { FaInfoCircle } from "react-icons/fa";
// 🧩 Dummy staff data (you can replace with actual API/redux data)
const staffData = [
  {
    name: "Darshan Sir",
    avatar: "https://i.pravatar.cc/150?img=11",
    unread: 1,
    title: "Darshan Sir",
    chat: [
      {
        from: "Darshan Sir",
        avatar: "https://i.pravatar.cc/150?img=11",
        text: "Have a great working week!!",
        time: "09:25 AM",
        side: "left",
        read: false,
      },
      {
        from: "You",
        avatar: "https://i.pravatar.cc/150?img=33",
        text: "You did your job well!!",
        time: "09:25 AM",
        side: "right",
        read: true,
      },
      {
        from: "Darshan Sir",
        avatar: "https://i.pravatar.cc/150?img=11",
        text: "what are the updates of my assignment and when is the deadline .Please make sure to guide me .",
        time: "09:25 AM",
        side: "left",
        read: false,
      },
      {
        from: "You",
        avatar: "https://i.pravatar.cc/150?img=33",
        text: "Okay Let me check on it.",
        time: "09:25 AM",
        side: "right",
        read: true,
      },
    ],
  },
  {
    name: "Varun Sir",
    avatar: "https://i.pravatar.cc/150?img=12",
    unread: 0,
    title: "Varun Sir",
    chat: [
      {
        from: "Varun Sir",
        avatar: "https://i.pravatar.cc/150?img=12",
        text: "Hi sir ! This is Darshan",
        time: "5:22 PM",
        side: "left",
        read: true,
      },
    ],
  },
];

const StaffMessages = () => {
  const [activeTab, setActiveTab] = useState("All");
  const [searchValue, setSearchValue] = useState("");

  const tabOptions = [{ label: "All" }, { label: "Unread" }];

  return (
    <div className={styles.pageWrapper}>
      <div className={styles.infoText}>
        <FaInfoCircle className={styles.infoIcon} />
        <span>Any staff can respond to parent message</span>
      </div>
      <div className={styles.messagingContainer}>
        {/* Header */}
        <div className={styles.headerRow}>
          <TabSelector
            options={tabOptions}
            activeTab={activeTab}
            setActiveTab={setActiveTab}
          />
          <div className={styles.searchBar}>
            <SearchBar
              placeholder="Search by name"
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </div>
          <span className={styles.showAllContacts}>Show all Staff</span>
        </div>

        {/* Chat Area */}
        <div className={styles.messagingContent}>
          <AllMessaging
            type="staff"
            data={staffData}
            searchQuery={searchValue}
            filterUnread={activeTab === "Unread"}
          />
        </div>
      </div>
    </div>
  );
};

export default StaffMessages;
